module.exports = __webpack_public_path__ + "img/agma2015-2-B15_fig03_agma-classification-individual-tols.597318d2.png";